import {
  createComponentAdmin,
  PublishesTo,
  SubscribesTo,
  type SchemaTypeHelper,
} from '@backstage-components/base';
import {Type, type Static} from '@sinclair/typebox';

export const reactName = 'Embed';
export const name = reactName;
export const description = reactName;

export const schema = Type.Object({
  content: Type.String({
    title: 'Embed Content',
    description: 'Script tags (<script>) are not allowed',
  }),
  targetOrigin: Type.Optional(
    Type.String({
      title: 'Target Origin',
      description:
        'When using an iframe, specifies what the origin the iframe window must be for the event to be dispatched',
      default: '*',
    })
  ),
});

const uiSchema = {
  'ui:groups': {
    'ui:template': 'tabs',
    sections: [
      [
        'Properties',
        [
          {
            'ui:template': 'accordion',
            sections: [['Embed Properties', ['targetOrigin', 'content']]],
          },
        ],
      ],
      [
        'Styling',
        [
          {
            'ui:template': 'accordion',
            sections: [['Custom Styles', ['styleAttr']]],
          },
        ],
      ],
      ['Animations', []],
    ],
  },
  content: {
    'ui:widget': 'modalTextareaWidget',
    'ui:options': {
      buttonTitle: 'Content',
      editor: 'CodeMirror',
    },
  },
};

const defaultFieldData: Static<typeof schema> = {
  content: '',
  targetOrigin: '*',
};

const instructions = Type.Union([
  SubscribesTo({
    topic: `${reactName}:SendPostMessage`,
    description: 'Send message to iframe',
    meta: {
      message: Type.Optional(
        Type.Unknown({
          title: 'Message',
          description: 'The message to send to the iframe',
        })
      ),
      targetOrigin: Type.Optional(
        Type.String({
          title: 'Target Origin',
          description:
            'Specifies what the origin the iframe window must be for the event to be dispatched',
        })
      ),
    },
  }),
  PublishesTo({
    topic: `${reactName}:onReceivedPostMessage`,
    description: 'Message recieved from iframe',
    meta: {
      message: Type.Optional(
        Type.Unknown({
          title: 'Message',
          description: 'The message recieved from the iframe',
        })
      ),
    },
  }),
]);

export const ComponentDefinition = createComponentAdmin({
  id: 'e1e79a1c-0995-4973-a14a-edb392080b47',
  reactName,
  name,
  category: 'component',
  description,
  defaultFieldData,
  instructions,
  schema,
  slotConfiguration: {},
  slug: reactName,
  uiSchema,
  version: 1,
})
  .withStyles()
  .build();

export type SchemaType = SchemaTypeHelper<typeof ComponentDefinition>;
